
export default
{
  bLoginOk: 0,
  Username: '',
  Loginname: '',
  UID: -1,
  UserPower: 0,
  PowerStr: '',
  UserJobNo: 0,
  Groups: 0,
  CMPISGroup: 0,
  CMPGroupName: '',
  SaleGRStr: '',
  compID: -1,
  compname: '东莞市倍升软件有限公司',
  complog: '',
  UserDepart: '',
  SysDept: '',
  UserProDeP: 0,
  UserInter: 0,
  FontSale: 1,
  InternetIP: '',
  UserId: '', // "IPSSQL",
  SalesNOTProcessor: 0,
  IsLoacteDB: 0,
  POSendSup: 0,
  X64: 0,
  BusyDay: 3,
  PowerWhere: [ '', '' ],
  MesErr: '',

  setaAToken (Username) {
    this.Username = Username
  },
  setaAToken (Loginname) {
    this.Loginname = Loginname
  },
  setaAToken (UID) {
    this.UID = UID
  },
  setaAToken (UserPower) {
    this.UserPower = UserPower
  },
  setaAToken (PowerStr) {
    this.PowerStr = PowerStr
  },
  setaAToken (UserJobNo) {
    this.UserJobNo = UserJobNo
  },
  setaAToken (UserJobNo) {
    this.UserJobNo = UserJobNo
  },
  setaAToken (Groups) {
    this.Groups = Groups
  },
  setaAToken (CMPISGroup) {
    this.CMPISGroup = CMPISGroup
  },
  setaAToken (CMPGroupName) {
    this.CMPGroupName = CMPGroupName
  },

  setaAToken (SaleGRStr) {
    this.SaleGRStr = SaleGRStr
  },
  setaAToken (compID) {
    this.compID = compID
  },
  setaAToken (compname) {
    this.compname = compname
  },
  setaAToken (complog) {
    this.complog = complog
  }
  //  da=resl[0]
  // this.compID=da["compid"];
//  this.defined.setAToken(result.data.access_token);
//  this.defined.setRToken(result.data.refresh_token);
}



// WEBPACK FOOTER //
// ./src/js/defined.js